import { useQuery } from 'react-query';

// app
import { adminAxios } from 'lib/admin/admin.api';
import { OPERATIONAL_MARKETS } from 'lib/admin/queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import config from 'config';

export const useGetOperationalMarkets = (params = {}) => {
  const { name, page, size, firstLetterFilter } = params;
  const endpointParams = {
    ...(firstLetterFilter && firstLetterFilter !== '' && { firstLetterFilter: firstLetterFilter }),
    page: page || 0,
    size: size || config.ui.gridPagination.default,
    orderBy: 'name',
    direction: 'asc',
    ...(name && { name }),
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.queries.useGetOperationalMarkets',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  return useQuery(
    [OPERATIONAL_MARKETS, endpointParams],
    async () => {
      const result = await adminAxios.get('marketParent', { params: endpointParams });

      return result?.data;
    },
    {
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
